import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import type { CheckoutFormValuesProps } from "../../types/CheckoutFormValuesProps";
import { useOnSubmit } from "./useOnSubmit";

export const useProcessSubmission = () => {
  const { getValues } = useFormContext<CheckoutFormValuesProps>();
  const { onSubmit } = useOnSubmit();

  return useCallback(async (): Promise<void> => {
    const data = getValues();
    await onSubmit(data);
  }, [getValues, onSubmit]);
};
